import Vue from "vue";
import App from "./App";
import router from "./router";
import GoBack from "./plugin/GoBack"; // 后退一步
import Upload from "./components/Upload.vue"; // 大文件分片上传
// import UploadImage from "./components/UploadImage.vue";
import UserAgreement from "./components/UserAgreement.vue"; // 用户协议
import SlideDown from "./plugin/SlideDown.vue"; // 默认向下滑动提示
import routerStage from "./plugin/routerStage.vue"; // 阶段进度判断
// import req from "./newAxios";
// Vue.prototype.axios = req;
import axios from "axios";
import VueAxios from "vue-axios";
// import "default-passive-events"; // 是否会调用preventDefault函数来阻止事件的默认行为
Vue.use(VueAxios, axios);
axios.defaults.baseURL = "https://alienware.eventnet.cn/";
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['content-Type'] = 'application/json';
Vue.component("GoBack", GoBack);
Vue.component("Upload", Upload);
// Vue.component("UploadImage", UploadImage);
Vue.component("UserAgreement", UserAgreement);
Vue.component("SlideDown", SlideDown);
Vue.component("routerStage", routerStage);
/* VideoPlayer播放器 */
// import VideoPlayer from "vue-video-player";
// import "video.js/dist/video-js.css";
// import "../static/custom-theme.css";
// Vue.use(VideoPlayer);
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(Element);
/* 自定义弹窗提示 */
import "./cToast.js";
/* vue-waterfall2 基于Vue.js 瀑布流 组件 https://segmentfault.com/a/1190000017042878 */
// import waterfall from "vue-waterfall2";
// Vue.use(waterfall);

new Vue({
    el: "#app",
    router,
    components: {
        App
    },
    template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js